import React, { useEffect, useState } from "react";
import Spreadsheet from "react-spreadsheet";
import '../styles.css';

const ExcelTable = ({ 
  data,
  setData,
  colsItems, 
  rowsItems, 
  HeaderRow, 
  Row,
  CustomDataViewer,
  isCheckBox}) => {

  const cols = colsItems.map(item => item.name);
  const rows = rowsItems.map(item => item.name);
  const [row, setRow] = useState(null);
  const [col, setCol] = useState(null);
  const [cellValue, setCellValue] = useState(null);
  const [cellChecked, setCellChecked] = useState(false);

  const handleChange = ( d ) => {
    d.forEach((rowData, rowIndex) => 
      rowData.forEach((cell, colIndex) =>
        {
          if (cell.value !== data[rowIndex][colIndex].value ){
            setRow(rowIndex);
            setCol(colIndex);
            setCellValue(cell.value === undefined ? '' : cell.value);
          } 
        }
      )
    );
  };
  
  useEffect(() => {
    if (data.length > 0 && 
        row !== null && 
        col !== null && 
        cellValue !== null && 
        cellChecked !== null &&
        data !== undefined
      ){
      const newData = data.map((rowData, rowIndex) =>
        rowData.map((cell, colIndex) =>
          rowIndex === row && colIndex === col
            ? { ...cell, value: cellValue, checked: cellChecked }
            : cell
        )
      );
      setData(newData);
      setRow(null);
      setCol(null);
      setCellValue(null);
    }
  }, [row, col, cellValue, cellChecked]); 

  return(
    <Spreadsheet
      data={data}
      onChange={(e) => handleChange(e)}
      columnLabels={cols}
      rowLabels={rows}
      HeaderRow={HeaderRow}
      DataViewer={CustomDataViewer}
      onSelect={(e) => {
        if (isCheckBox === undefined || isCheckBox === false) {
          return;
        }
        if (e.range === undefined || e.range === null) {
          return;
        }
        const checked = !data[e.range?.start?.row][e.range?.start?.column]?.checked;
        setCellChecked(checked);
        setRow(e.range.start.row);
        setCol(e.range.start.column);
        setCellValue(checked ? 'x' : '');
      }}
      Row={Row}/> 
  )
};

export default ExcelTable;
